import {z} from 'zod';

import {FinancialProductTypeSchema} from './FinancialProductTypeSchema';
import {LeasingTargetGroupSchema} from './LeasingTargetGroupSchema';

export const FinancialProductPreferenceCoordinatesSchema = z.object({
  productType: FinancialProductTypeSchema,
  termMonths: z.number().nullable(),
  downPaymentPercentage: z.number().nullable(),
  balloonPaymentPercentage: z.number().nullable(),
  leasingTargetGroup: LeasingTargetGroupSchema.nullable(),
  annualMileage: z.number().nullable(),
});
export type FinancialProductPreferenceCoordinates = z.infer<
  typeof FinancialProductPreferenceCoordinatesSchema
>;
